export default function useLocalBatchData() {

    const getData = (partitionKey, includeExpiration) => {
        const rawData = localStorage.getItem(`${partitionKey}-batch-data`);
        if (!rawData) {
            return [];
        }

        const localBatches = JSON.parse(rawData);
        const filteredLocalBatches = localBatches.filter(lb => lb.expiresOn && lb.expiresOn > new Date().getTime());
        if (includeExpiration) {
            return filteredLocalBatches;
        }
        return filteredLocalBatches.map(lb => lb.data);
    };

    const saveData = (data, partitionKey) => {
        const existingBatches = getData(partitionKey, true);
        const newList = [];
        if (existingBatches) {
            for(const existingBatch of existingBatches) {
                const matchingBatch = data.find(d => d.batchId === existingBatch.batchId);
                if (matchingBatch) {
                    newList.push({
                        data: matchingBatch,
                        expiresOn: existingBatch.expiresOn
                    });
                }
            }
        }

        if (newList.length !== data.length) {
            for(const batch of data) {
                const existingBatch = newList.find(nl => nl.data.batchId === batch.batchId);
                if (!existingBatch) {
                    newList.push({
                        data:batch,
                        expiresOn: new Date().getTime() + 1209600000 // 2 weeks?
                    });
                }
            }
        }

        const distinctList = [];

        for(const item of newList) {
            const existingItem = distinctList.find(dl => dl.data.batchId === item.data.batchId);
            if (!existingItem) {
                distinctList.push(item);
            }
        }

        localStorage.setItem(`${partitionKey}-batch-data`, JSON.stringify(distinctList));
    };

    const clearData = (partitionKey) => {
        localStorage.removeItem(`${partitionKey}-batch-data`);
    }

    return {
        get: getData,
        save: saveData,
        clear: clearData
    };
}